import { KitIcon, KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import { useNavigation } from '@react-navigation/native';
import React, { useEffect } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useSelector } from 'react-redux';

import { DISCOVER_TAB } from '../../../Constants';
import {
  canCreateChannelsSelector,
  canCreateDirectMessageSelector,
  publicChannelListSelector,
} from '../../../redux/selectors';

//******************************************************************************
// Component
//******************************************************************************

interface EmptyConversationListLargeProps {
  navToDiscover: () => void;
}

export default function EmptyConversationListLarge({
  navToDiscover,
}: EmptyConversationListLargeProps): JSX.Element {
  const { t } = useTranslation(['messaging']);

  const canCreateChannels = useSelector(canCreateChannelsSelector);
  const canCreateDirectMessage = useSelector(canCreateDirectMessageSelector);
  const publicChannels = useSelector(publicChannelListSelector);

  // const navigation = useNavigation();

  const canCreate = canCreateDirectMessage || canCreateChannels;

  useEffect(() => {
    if (publicChannels && publicChannels?.length > 0) {
      navToDiscover();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicChannels]);

  const _renderText = () => {
    if (publicChannels && publicChannels.length > 0) {
      return (
        <View>
          <KitText black fontSize={26} bold style={styles.headerText}>
            {t('messaging:letsGetTheConversationStarted')}
          </KitText>
          {canCreate ? (
            <KitText gray fontSize={16} style={styles.paragraphText}>
              {t('messaging:joinAGroupOrComposeANewMessageToGetStarted')}
            </KitText>
          ) : (
            <KitText gray fontSize={16} style={styles.paragraphText}>
              {t('messaging:joinAGroupToGetStarted')}
            </KitText>
          )}
        </View>
      );
    } else if (canCreate) {
      return (
        <View>
          <KitText black fontSize={26} bold style={styles.headerText}>
            {t('messaging:letsGetTheConversationStarted')}
          </KitText>
          <KitText gray fontSize={16} style={styles.paragraphText}>
            {t('messaging:newMessageGuidance')}
          </KitText>
        </View>
      );
    } else {
      return (
        <View>
          <KitText black fontSize={26} bold style={styles.headerText}>
            {t('messaging:nothingToSeeHereYet')}
          </KitText>
          <KitText gray fontSize={16} style={styles.paragraphText}>
            {t('messaging:youHaventBeenAddedToAnyGroupsNotice')}
          </KitText>
          <KitText
            gray
            fontSize={16}
            style={[styles.paragraphText, { marginTop: Spacing.m }]}
          >
            {t('messaging:groupMembershipGuidance')}
          </KitText>
        </View>
      );
    }
  };

  return (
    <View style={styles.container}>
      <KitIcon name='messaging' color='#999b9e' size={44} />
      {_renderText()}
    </View>
  );
}

//******************************************************************************
// Styles
//******************************************************************************
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.N0,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: Spacing.xxl,
    paddingBottom: Spacing.xxl,
  },
  headerText: {
    marginTop: Spacing.m,
    marginBottom: Spacing.m,
    textAlign: 'center',
  },
  paragraphText: {
    lineHeight: 24,
    textAlign: 'center',
  },
});
